import '../../../less/afsp-login.less';
import AfspLogin from './AfspLogin';

export default class extends React.Component {
    constructor(props) { super(props); }
    render = () => <AfspLogin 
        {...this.props}
        portal='fsdo'
        registrationPath='/home?portal=fsdo'
    />;
}